


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ChevronsDownIcon } from 'vue-feather-icons';
import { FivGoalSubGroupType, IFivReport, IGoal } from 'admiral-core';
import dayjs from 'dayjs';

@Component({ components: { ChevronsDownIcon } })
export default class CompetitionsReportCard extends Vue {
  @Prop({ type: Object })
  competitionsReport!: IFivReport;

  @Prop({ type: Array })
  competitionsReportGoals!: IGoal[];

  showAll = false;

  get competitionsReportGoalNames() {
    return this.competitionsReportGoals.map((goal: IGoal) => goal.name);
  }

  isUnimportant(goal: IGoal) {
    return !this.competitionsReportGoalNames.includes(goal.name);
  }

  get reportDate() {
    const dateDayJs = dayjs(this.competitionsReport.reportDate);
    return dateDayJs.format('DD.MM.YYYY');
  }

  get dataDate() {
    const dateDayJs = dayjs(this.competitionsReport.dataDate);
    return dateDayJs.format('DD.MM.YYYY');
  }

  get fromInterval() {
    const dateDayJs = dayjs(this.competitionsReport.timespanStart);
    return dateDayJs.format('MM/YYYY');
  }

  get toInterval() {
    const dateDayJs = dayjs(this.competitionsReport.timespanEnd);
    return dateDayJs.format('MM/YYYY');
  }

  mapCompetitionName(type: FivGoalSubGroupType) {
    switch (type) {
      case FivGoalSubGroupType.CompetitionHessClub:
        return 'Dr. Hans Heß Club';
      case FivGoalSubGroupType.CompetitionRingEh:
        return 'Ringausschreibung EH';

      case FivGoalSubGroupType.CompetitionRingGold:
        return 'Gold-Ziele';

      case FivGoalSubGroupType.CompetitionRingSilver:
        return 'Silber-Ziele';

      case FivGoalSubGroupType.CompetitionRingBronze:
        return 'Bronze-Ziele';
      case FivGoalSubGroupType.CompetitionKbvWinnersClub:
        return 'Sieger-Club';
      case FivGoalSubGroupType.CompetitionFallAds:
        return 'Herbstwerbung';
      default:
        return '-';
    }
  }
}
